import { render, staticRenderFns } from "./aboutus-cnt1.vue?vue&type=template&id=62c67d8d&scoped=true&"
import script from "./aboutus-cnt1.vue?vue&type=script&lang=js&"
export * from "./aboutus-cnt1.vue?vue&type=script&lang=js&"
import style0 from "./aboutus-cnt1.vue?vue&type=style&index=0&id=62c67d8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c67d8d",
  null
  
)

export default component.exports